import apiClient from './apiClient';

export const getAnnouncements = (params) => {
    return apiClient.get('/announcement', { params })
      .then(response => ({
        data: {
          items: response.data.rows,
          total: response.data.count
        }
      }));
  };
  
  export const createAnnouncement = (data) => apiClient.post('/announcement', data);
  export const updateAnnouncement = (id, data) => apiClient.put(`/announcement/${id}`, data);
  export const deleteAnnouncement = (id) => apiClient.delete(`/announcement/${id}`);